// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD9kPsIQwW0Vktn73NUdZPblbiVGtMC0to",
  authDomain: "cardinalgrid.firebaseapp.com",
  projectId: "cardinalgrid",
  storageBucket: "cardinalgrid.firebasestorage.app",
  messagingSenderId: "13230993918",
  appId: "1:13230993918:web:cdef4bccf782ba5b4190af",
  measurementId: "G-5REV2D003S"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };
